module.exports = __webpack_public_path__ + "static/media/anything-goes-3.9ea410c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facts/anything-goes-3.jpg
// module id = 119
// module chunks = 0